/* KleenKick V3 — Loader: exact 1.2s reveal, premium drop feel */
(function () {
  'use strict';

  // Skip loader on returning visit within session (UX-friendly)
  const SEEN_KEY = 'kk_loader_seen';
  const alreadySeen = sessionStorage.getItem(SEEN_KEY);

  if (!alreadySeen) {
    document.body.classList.add('is-loading');
    document.documentElement.classList.add('is-loading');
  }

  const minDuration = alreadySeen ? 200 : 1200; // ms
  const start = performance.now();

  function ready() {
    const elapsed = performance.now() - start;
    const remaining = Math.max(0, minDuration - elapsed);

    setTimeout(() => {
      document.body.classList.remove('is-loading');
      document.documentElement.classList.remove('is-loading');
      document.body.classList.add('is-loaded');
      sessionStorage.setItem(SEEN_KEY, '1');

      // Dispatch event for other scripts (slider auto-glide, GSAP reveals)
      document.dispatchEvent(new CustomEvent('kk:loaded'));
    }, remaining);
  }

  if (document.readyState === 'complete') {
    ready();
  } else {
    window.addEventListener('load', ready);
  }
})();
